import { ExperienceLevel } from "@src/API";

export const experienceLevels = [
  { key: "intern", text: "Intern", value: ExperienceLevel.INTERN },
  { key: "junior", text: "Junior", value: ExperienceLevel.JUNIOR },
  { key: "midlevel", text: "Mid Level", value: ExperienceLevel.MIDLEVEL },
  { key: "senior", text: "Senior", value: ExperienceLevel.SENIOR },
  { key: "executive", text: "Executive", value: ExperienceLevel.EXECUTIVE },
];

export const internshipTypes = [
  {
    key: "Software Engineering",
    text: "Software Engineering",
    value: "Software Engineering",
  },
  { key: "Design", text: "Design", value: "Design" },
  { key: "Marketing", text: "Marketing", value: "Marketing" },
  { key: "Finance", text: "Finance", value: "Finance" },
  { key: "Sales", text: "Sales", value: "Sales" },
  { key: "HR", text: "HR", value: "HR" },
];

// [
//   {
//      regexp: {
//         scrapedUrl: '.*greenhouse.*'
//      }
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*lever.*'
//      }
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*workable.*'
//      }
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*applytojob.*'
//      }
//   },                                    
//   {
//      regexp: {
//         scrapedUrl: '.*breezy.*'
//      }                                        
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*comeet.*'
//      }                                        
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*ashbyhq.*'
//      }                                        
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*recruitee.*'
//      }                                        
//   },
//   {
//      regexp: {
//         scrapedUrl: '.*jobvite.*'
//      }                                        
//   }                                                                                                                                                
// ]

export const supportedJobBoards = [
  "greenhouse",
  "lever",
  "workable",
  "applytojob",
  // "breezy",
  "comeet",
  "ashbyhq",
  "recruitee",
  "jobvite",  
]

export const jobBoardClause = supportedJobBoards.map(jobBoard => {
  return {
     regexp: {
        scrapedUrl: `.*${jobBoard}.*`
     }
  }
})    